export const PULSE_LOGO = 'https://cdn.magicpatterns.com/uploads/w1KTX8d414GHbDguKdnfs4/image.png';

export const loanOfficer = {
  name: 'Marcus Bennett',
  firstName: 'Marcus',
  title: 'Your Loan Officer',
  nmls: 'NMLS #1849302',
  phone: '(512) 555-0142',
  photo: 'https://cdn.magicpatterns.com/patterns/generated-images/43863ac8-37be-442f-96c8-779fb1c9208d.jpg',
};

export const processor = {
  name: 'Sarah Kim',
  firstName: 'Sarah',
  title: 'Loan Processor',
  photo: 'https://cdn.magicpatterns.com/patterns/generated-images/11fbb12a-a63a-4dc8-a3cb-93d45ea058c5.jpg',
};

export const propertyPhoto =
  'https://cdn.magicpatterns.com/patterns/generated-images/8e992b34-0ef5-4ef6-9c63-ac07d8f6f5d1.jpg';
